import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "cluster-hlist" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "action" }

import { computed, useTemplateRef } from 'vue';
import { RecycleScroller } from 'vue-virtual-scroller';

import { t } from '@services/l10n';
import { useRouteIs } from '@services/route-is';
import { useRouteState } from '@services/route-state';
import { windowDims } from '@services/viewport';

import Cluster from '@components/frame/Cluster.vue';

import type { ICluster } from '@typings';

const CLUSTER_SIZE = 140;
const CLUSTER_SIZE_MOBILE = 120;
const CIRCLE_HEIGHT = 176;
const CIRCLE_HEIGHT_MOBILE = 152;
const ITEM_GAP = 4; // 2px margin on each side


export default /*@__PURE__*/_defineComponent({
  __name: 'ClusterHList',
  props: {
    stateKey: {},
    clusters: {},
    title: {},
    link: {},
    circle: { type: Boolean }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v787b4bf5": (clusterWidth.value),
  "v4d6e5448": (circleHeightPx.value)
}))

const props = __props;

const recycler = useTemplateRef<VueRecyclerType>('recycler');
const routeIs = useRouteIs();

useRouteState({
  instance: props.stateKey,
  scroll: { recycler },
});

const clusterSize = computed(() => (windowDims.isMobile ? CLUSTER_SIZE_MOBILE : CLUSTER_SIZE));
const circleHeight = computed(() => (windowDims.isMobile ? CIRCLE_HEIGHT_MOBILE : CIRCLE_HEIGHT));

const itemSize = computed(() => clusterSize.value + ITEM_GAP);
const clusterWidth = computed(() => `${clusterSize.value}px`);
const circleHeightPx = computed(() => `${circleHeight.value}px`);
const listHeight = computed(() => (props.circle ? circleHeight.value : clusterSize.value));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(props.title), 1),
          _createElementVNode("div", _hoisted_4, [
            (props.link)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: props.link
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('memories', 'View all')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(RecycleScroller), {
      ref_key: "recycler",
      ref: recycler,
      class: "hlist hide-scrollbar",
      direction: "horizontal",
      items: props.clusters,
      "key-field": "cluster_id",
      "item-size": itemSize.value,
      "skip-hover": true,
      style: _normalizeStyle({ height: `${listHeight.value}px` }),
      "disable-transform": true
    }, {
      default: _withCtx(({ item }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["item cluster--rounded", { 'cluster--circle': props.circle }])
        }, [
          _createVNode(Cluster, {
            data: item,
            link: true,
            counters: !_unref(routeIs).Explore
          }, null, 8, ["data", "counters"])
        ], 2)
      ]),
      _: 1
    }, 8, ["items", "item-size", "style"])
  ]))
}
}

})